import { BaseContainerModel } from '../base-container.model';
import {
    bl_fi_generic_doc_message_template_line_RowClass,
  } from '../../dbschema/index';
export class GenericDocMessageTemplateLineContainerModel extends BaseContainerModel {
    bl_fi_generic_doc_message_template_line: bl_fi_generic_doc_message_template_line_RowClass;

}